<template>
  <div>
    <busy-btn
      v-for="({text}, idx) in $options.periods"
      :key="idx"
      :variant="periodIdx === idx ? 'primary' : 'outline-primary'" class="mr-1" @click="switchPeriod(idx)"
      :busy="periodIdx === idx && busy"
    >{{text}}</busy-btn>

    <div id="chart"><apexchart type="line" height="250" :options="chartOptions" :series="series"/></div>

    <div id="chart2"><apexchart type="line" height="250" :options="chartOptions2" :series="series2"/></div>

  </div>
</template>

<script>
import identity from 'lodash/identity';
import moment   from 'moment';
import nl from 'apexcharts/dist/locales/nl.json';

import BusyBtn  from '@/components/BusyBtn';


const chartOptions = 
{
    chart:
    {
        animations: { enabled: false },
        type: 'line',
        stacked: false,
        locales: Object.freeze([nl]),
        defaultLocale: 'nl',
        toolbar:
        {
            tools:
            {
                download: true,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false
            }
        }
    },
    colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#1B998B'],
    dataLabels: { enabled: false },
    markers: { size: 5 },
    stroke: { curve: 'straight' },
    tooltip: { shared: true },
    xaxis:
    {
        type: 'datetime',
        labels: { datetimeUTC: false }
    },
    yaxis: { min: identity, labels: { formatter(v) { return v.toFixed(0); } } }
}


export default
{
    apollo:
    {
        $subscribe:
        {
            printer:
            {
                query: require('../graphql/live/printer_history.gql'),
                result({data: { printerHistory }})
                {
                    this.series   = [];
                    this.series2  = [];

                    let h;
                    
                    for (h of printerHistory)
                    {
                        if(h.type === 'COUNTER')
                            this.series.push({ name: h.displayName, data: h.data });
                        else
                            this.series2.push({ name: h.displayName, data: h.data });
                    }

                    this.busy = false;
                },
                variables()
                {
                    return {
                        end:        this.end,
                        id:         this.id,
                        start:      this.start
                    }
                }
            }
        }
    },
    components: { BusyBtn },
    data()
    {
        const periodIdx = 0;
        const period = this.$options.periods[periodIdx];
        const start = period.start();
        const end   = period.end();
        
        return {
            busy: true,
            periodIdx,
            series: [],
            series2: [],
            start,
            end,
            chartOptions:
            {
                ...chartOptions,
                xaxis: { ...chartOptions.xaxis, min: start, max: end },
                yaxis: { ...chartOptions.yaxis }
            },
            chartOptions2:
            {
                ...chartOptions,
                colors: ['#00FFFF', '#ff00ff', '#FFD700', '#000000', '#D2D2CF'],
                xaxis: { ...chartOptions.xaxis, min: start, max: end },
                yaxis: { ...chartOptions.yaxis, min: 0, max: 100, title: { text: '%' } }
            }
        }
    },
    methods:
    {
        switchPeriod(idx)
        {
            const period    = this.$options.periods[idx];

            this.busy       = true;
            this.periodIdx  = idx;
            this.start      = period.start();
            this.end        = period.end();

            this.chartOptions   = { xaxis: { max: this.end, min: this.start } };
            this.chartOptions2  = { xaxis: { max: this.end, min: this.start } }
        }
    },
    props:
    {
        id: { type: String, required: true }
    },
    periods:
    [
        { text: '1M', start() { return moment().subtract(1, 'months').valueOf() }, end: Date.now },
        { text: '3M', start() { return moment().subtract(3, 'months').valueOf() }, end: Date.now },
        { text: '6M', start() { return moment().subtract(6, 'months').valueOf() }, end: Date.now },
        { text: '1Y', start() { return moment().subtract(1, 'years').valueOf() }, end: Date.now },
        { text: 'YTD', start() { return moment().startOf('year').valueOf() }, end: Date.now }
    ]
}
</script>

<style>
</style>